import React, { useState } from 'react';
import LocationList from './components/LocationList';
import LocationCreate from './components/LocationCreate';
import { BaseLayout } from '../../layouts';
import { useTranslation } from 'react-i18next';
import * as routes from '../../app/routes';
import { Add } from '@mui/icons-material';

function Location() {
  const [translate] = useTranslation();
  const [createOp, setCreateOp] = useState(false);

  const handleClick = () => {
    setCreateOp(true);
  };

  const handleDialogClosing = () => {
    setCreateOp(false);
  };

  return (
    <BaseLayout
      moduleName={translate('locations', 'Lokacijos')}
      modulePath={routes.ROUTE_LOCATION.path}
      isDocumentList
      button={{
        btnIcon: <Add />,
        btnText: translate('new', 'Sukurti naują'),
        btnOnClick: handleClick
      }}
    >
      {createOp && <LocationCreate open={createOp} onClose={handleDialogClosing} />}
      <LocationList />
    </BaseLayout>
  );
}

export default Location;
